export const SUB_NAVIGATION_ID = 'urc-SubNavigation';
//# sourceMappingURL=constants.js.map